module.exports = __webpack_public_path__ + "static/media/cubre.28aedde6.svg";